import apiClient from './apiClient';

export const initiateGoogleAuth = async () => {
    return apiClient.get('calendar/oauth/initiate');
};

export const listCalendarEvents = async () => {
    return apiClient.get('calendar/events'); 
};

export const getHolidays = async () => {
    return apiClient.get('calendar/holidays'); 
};

export const createCalendarEvent = async (eventData) => {
    return apiClient.post('calendar/events', eventData); 
};

export const confirmGoogleLink = async (token) => {
    return apiClient.post('calendar/oauth/confirm', { token }); 
};

export const disconnectGoogle = async () => {
    return apiClient.delete('calendar/oauth/disconnect'); 
};